import { Component } from '@angular/core';
import { environment } from 'src/environments/environment';


@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'hotelWebsite';
}
export const APP_ID = environment.appId;
export const PROPERTY_ID = environment.propertyId;
